type AppConfig = {
  BE_URL: string
  KEYCLOAK_AUTHORITY: string
  KEYCLOAK_CLIENT_ID: string
}

let config: AppConfig | null = null

export const loadConfig = async (): Promise<void> => {
  const response = await fetch('/config/config.json')
  config = await response.json()
}

export const getConfig = (): AppConfig => {
  if (!config) throw new Error('Config not loaded')
  return config
}
